import React from "react";
import PractitionerDirectory from "./PractitionerDirectory"; // Import the component

const Practitioner = () => {
  // Function to generate random Indian names
  function generateRandomIndianName() {
    const indianFirstNames = [
      "Amit",
      "Sneha",
      "Neha",
      "Arun",
      "Anjali",
      "Ritik",
      "Deepika",
      "Preeti",
      "Rakesh",
      "Suman",
    ];
    const indianLastNames = [
      "Gupta",
      "Sharma",
      "Patel",
      "Verma",
      "Singh",
      "Jain",
      "Mishra",
      "Pandey",
      "Yadav",
      "Choudhary",
    ];

    const randomFirstName =
      indianFirstNames[Math.floor(Math.random() * indianFirstNames.length)];
    const randomLastName =
      indianLastNames[Math.floor(Math.random() * indianLastNames.length)];

    return `Dr. ${randomFirstName} ${randomLastName}`;
  }

  // Function to generate random Indian locations
  function generateRandomIndianLocation() {
    const indianLocations = [
      "Mumbai, Maharashtra",
      "Delhi, Delhi",
      "Kolkata, West Bengal",
      "Bangalore, Karnataka",
      "Chennai, Tamil Nadu",
      "Hyderabad, Telangana",
      "Pune, Maharashtra",
      "Ahmedabad, Gujarat",
      "Jaipur, Rajasthan",
      "Lucknow, Uttar Pradesh",
    ];

    return indianLocations[Math.floor(Math.random() * indianLocations.length)];
  }

  // Function to generate random Indian-style contact
  function generateRandomIndianContact() {
    const domains = [
      "gmail.com",
      "yahoo.co.in",
      "outlook.in",
      "rediffmail.com",
      "hotmail.com",
    ];
    const randomDomain = domains[Math.floor(Math.random() * domains.length)];

    // Generate a random username
    const randomUsername = Math.random().toString(36).substring(2, 10);

    return `${randomUsername}@${randomDomain}`;
  }

  // Define an array of practitioners with Indian-style data
  const practitioners = [
    {
      name: generateRandomIndianName(),
      specialty: "Ayurvedic Dermatologist",
      location: generateRandomIndianLocation(),
      contact: generateRandomIndianContact(),
      imageLink:
        "https://tambeayurved.in/wp-content/uploads/sites/4/2015/08/ayurvedic-doctor-for-skin-disease.jpg",
    },
    {
      name: generateRandomIndianName(),
      specialty: "Homeopathic Gastroenterologist",
      location: generateRandomIndianLocation(),
      contact: generateRandomIndianContact(),
      imageLink:
        "https://www.felixhospital.com/sites/default/files/2022-11/best-homeopathy-hospital-in-noida.jpg",
    },
    {
      name: generateRandomIndianName(),
      specialty: "Ayurvedic Orthopedic Specialist",
      location: generateRandomIndianLocation(),
      contact: generateRandomIndianContact(),
      imageLink:
        "https://divyaniayurvedam.com/wp-content/uploads/2023/02/Ayurvedic-Treatment-of-Joint-Pain-768x432.jpg",
    },
    {
      name: generateRandomIndianName(),
      specialty: "Ayurvedic Cardiologist",
      location: generateRandomIndianLocation(),
      contact: generateRandomIndianContact(),
      imageLink:
        "https://www.raphacure.com/img/ayurveda/Rapha-Earth-Cardiac.webp",
    },
    {
      name: generateRandomIndianName(),
      specialty: "Homeopathic Pediatrician",
      location: generateRandomIndianLocation(),
      contact: generateRandomIndianContact(),
      imageLink:
        "https://julekmeissner.com/wp-content/uploads/2019/07/Children-and-homeopathy-1080x675.jpg",
    },
    {
      name: generateRandomIndianName(),
      specialty: "Homeopathic Allergist",
      location: generateRandomIndianLocation(),
      contact: generateRandomIndianContact(),
      imageLink:
        "https://www.svmcdelhi.com/blog/wp-content/uploads/2021/02/homeopathicdoctor.jpg",
    },
  ];

  return (
    <div className="Practitioner">
      <PractitionerDirectory practitioners={practitioners} />{" "}
      {/* Render the PractitionerDirectory component */}
    </div>
  );
};

export default Practitioner;

// import React from 'react';
// import PractitionerDirectory from './PractitionerDirectory'; // Import the component

// const Practitioner = () => {
//     // Define an array of practitioners
//     const practitioners = [
//         {
//             name: 'Dr. John Doe',
//             specialty: 'Cardiologist',
//             location: 'New York, NY',
//             contact: 'johndoe@example.com',
//         },
//         {
//             name: 'Dr. Jane Smith',
//             specialty: 'Dermatologist',
//             location: 'Los Angeles, CA',
//             contact: 'janesmith@example.com',
//         },
//         {
//             name: 'Dr. Michael Johnson',
//             specialty: 'Orthopedic Surgeon',
//             location: 'Chicago, IL',
//             contact: 'michaeljohnson@example.com',
//         },
//         {
//             name: 'Dr. Sarah Brown',
//             specialty: 'Pediatrician',
//             location: 'San Francisco, CA',
//             contact: 'sarahbrown@example.com',
//         },
//         {
//             name: 'Dr. David Lee',
//             specialty: 'Psychiatrist',
//             location: 'Houston, TX',
//             contact: 'davidlee@example.com',
//         },
//         {
//             name: 'Dr. Emily Adams',
//             specialty: 'Ophthalmologist',
//             location: 'Miami, FL',
//             contact: 'emilyadams@example.com',
//         },
//         {
//             name: 'Dr. Robert Taylor',
//             specialty: 'Neurologist',
//             location: 'Boston, MA',
//             contact: 'roberttaylor@example.com',
//         },
//         {
//             name: 'Dr. Laura Wilson',
//             specialty: 'Gynecologist',
//             location: 'Philadelphia, PA',
//             contact: 'laurawilson@example.com',
//         },
//         {
//             name: 'Dr. Christopher Clark',
//             specialty: 'Dentist',
//             location: 'Seattle, WA',
//             contact: 'christopherclark@example.com',
//         },
//         {
//             name: 'Dr. Melissa Martinez',
//             specialty: 'Rheumatologist',
//             location: 'Denver, CO',
//             contact: 'melissamartinez@example.com',
//         },
//         {
//             name: 'Dr. William White',
//             specialty: 'Urologist',
//             location: 'Atlanta, GA',
//             contact: 'williamwhite@example.com',
//         },
//         {
//             name: 'Dr. Jennifer Garcia',
//             specialty: 'Allergist',
//             location: 'Dallas, TX',
//             contact: 'jennifergarcia@example.com',
//         },
//         {
//             name: 'Dr. Richard Hall',
//             specialty: 'General Surgeon',
//             location: 'Phoenix, AZ',
//             contact: 'richardhall@example.com',
//         },
//         {
//             name: 'Dr. Maria Rodriguez',
//             specialty: 'Endocrinologist',
//             location: 'San Diego, CA',
//             contact: 'mariarodriguez@example.com',
//         },
//         {
//             name: 'Dr. Thomas Evans',
//             specialty: 'Oncologist',
//             location: 'Detroit, MI',
//             contact: 'thomasevans@example.com',
//         },
//         {
//             name: 'Dr. Elizabeth Green',
//             specialty: 'Dietitian',
//             location: 'Minneapolis, MN',
//             contact: 'elizabethgreen@example.com',
//         },
//         {
//             name: 'Dr. Kevin Baker',
//             specialty: 'Physical Therapist',
//             location: 'Portland, OR',
//             contact: 'kevinbaker@example.com',
//         },
//         {
//             name: 'Dr. Linda Adams',
//             specialty: 'Psychologist',
//             location: 'Charlotte, NC',
//             contact: 'lindaadams@example.com',
//         },
//         {
//             name: 'Dr. James Wilson',
//             specialty: 'Pulmonologist',
//             location: 'San Antonio, TX',
//             contact: 'jameswilson@example.com',
//         },
//         {
//             name: 'Dr. Patricia Harris',
//             specialty: 'Dental Hygienist',
//             location: 'Las Vegas, NV',
//             contact: 'patriciaharris@example.com',
//         },
//     ];

//     return (
//         <div className="Practitioner">
//             <PractitionerDirectory practitioners={practitioners} /> {/* Render the PractitionerDirectory component */}
//         </div>
//     );
// };

// export default Practitioner;
